import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import { useState } from 'react';
import Presupuestos from '../Presupuestos';
import Ventas from '../Ventas';
import './closer.scss';
import { useNavigate } from 'react-router-dom';
import CloserMetrics from './components/CloserMetrics';

const Closer = () => {
    const navigate = useNavigate();
    const [tab, setTab] = useState('presupuestos');

    const handleChangeTab = (e, newTab) => {
        navigate('/closer/1');
        setTab(newTab);
    };

    return (
        <div className="w-100">
            <h1 className="ms-3">Closer</h1>
            <TabContext value={tab}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChangeTab} aria-label="Ajustes">
                        <Tab label="Presupuestos" value="presupuestos" />
                        <Tab label="Ventas" value="ventas" />
                        <Tab label="Metricas" value="metricas" />
                    </TabList>
                </Box>
                <TabPanel
                    value="presupuestos"
                    style={{ height: 'calc(100vh - 145px)', overflowY: 'auto' }}
                    className="closer-tab-panel"
                >
                    <Presupuestos ecommerce={false} soporte={true} />
                </TabPanel>
                <TabPanel
                    value="ventas"
                    style={{ height: 'calc(100vh - 145px)', overflowY: 'auto' }}
                    className="closer-tab-panel"
                >
                    <Ventas soporte={true} />
                </TabPanel>
                <TabPanel
                    value="metricas"
                    style={{ height: 'calc(100vh - 145px)', overflowY: 'auto' }}
                    className="closer-tab-panel"
                >
                    <CloserMetrics />
                </TabPanel>
            </TabContext>
        </div>
    );
};

export default Closer;
